import { render, staticRenderFns } from "./FeaturedTVShows.vue?vue&type=template&id=4addc2c5&scoped=true&"
import script from "./FeaturedTVShows.vue?vue&type=script&lang=js&"
export * from "./FeaturedTVShows.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedTVShows.vue?vue&type=style&index=0&id=4addc2c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addc2c5",
  null
  
)

export default component.exports